export const environment = {
    production: false,
    appVersion: '1.0.25',
    brandName: 'DENmeet',
    brandLogoPath: 'logonew.png',
    apiBaseUrl: 'https://meetqaapi.rcmportal.com/',
    inactivityDuration: 900000, // 15 minutes in milliseconds
    wsUrl: 'wss://meetqaapi.rcmportal.com/socket/connect',
}
 